import { Component } from '@angular/core';
import { AuthService } from '../../../services/auth/auth.service';
import { Router } from '@angular/router';
import { ApplicantsService } from '../../../services/http/applicants/applicants.service';

@Component({
  selector: 'app-login-redirect',
  standalone: true,
  imports: [],
  templateUrl: './login-redirect.component.html',
  styleUrl: './login-redirect.component.scss'
})
export class LoginRedirectComponent {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly applicantService: ApplicantsService
  ) {
    this.setUser();
  }

  async setUser() {
    const valid = await this.authService.setUser(false);
    if (valid) {
      this.applicantService.getCurrentApplicant().subscribe({
        next: applicant => {
          sessionStorage.setItem('applicant', 'true');
          this.router.navigate(['/vehicles']);
        }, error: () => {
          sessionStorage.setItem('applicant', 'false');
          this.router.navigate(['/register']);
        }
      });
    } else {
      this.authService.logoutUser();
      this.router.navigate(['/login']);
    }
  }
}
